interface Bank {
	code: string;
	bankName: string;
	logo?: string;
	minLength?: number;
	maxLength?: number;
}

const BANK_LOGO_BASE_LINK = './assets/image/bankLogos/';
export const DEFAULT_BANK_LOGO = `${BANK_LOGO_BASE_LINK}otherBank.jpg`;
export const BANK_CONFIG: Bank[] = [
	{
		code: 'MAYBANK',
		bankName: 'MAYBANK',
		logo: `${BANK_LOGO_BASE_LINK}maybank.png`,
		minLength: 12,
		maxLength: 12
	},
	{
		code: 'PUBLIC_BANK',
		bankName: 'PUBLIC BANK',
		logo: `${BANK_LOGO_BASE_LINK}publicbank.png`,
		minLength: 10,
		maxLength: 10
	},
	{
		code: 'CIMB',
		bankName: 'CIMB BANK',
		logo: `${BANK_LOGO_BASE_LINK}cimb.jpg`,
		minLength: 9,
		maxLength: 14
	},
	{
		code: 'RHB',
		bankName: 'RHB BANK',
		logo: `${BANK_LOGO_BASE_LINK}rhbbank.png`,
		minLength: 14,
		maxLength: 14
	},
	{
		code: 'HONG_LEONG',
		bankName: 'HONG LEONG BANK',
		logo: `${BANK_LOGO_BASE_LINK}hongLeong.png`,
		minLength: 10,
		maxLength: 13
	},
	{
		code: 'BANK_MUAMALAT',
		bankName: 'BANK MUAMALAT',
		logo: `${BANK_LOGO_BASE_LINK}muamalatBank.png`,
		minLength: 14,
		maxLength: 17
	},
	{
		code: 'AFFIN_BANK',
		bankName: 'AFFIN BANK',
		logo: `${BANK_LOGO_BASE_LINK}affin.png`,
		minLength: 12,
		maxLength: 12
	},
	{
		code: 'BANK_ISLAM',
		bankName: 'BANK ISLAM',
		logo: `${BANK_LOGO_BASE_LINK}bankIslam.png`,
		minLength: 13,
		maxLength: 14
	},
	{
		code: 'AGRO_BANK',
		bankName: 'AGRO BANK',
		logo: `${BANK_LOGO_BASE_LINK}agrobank.png`,
		minLength: 16,
		maxLength: 17
	},
	{
		code: 'HSBC',
		bankName: 'HSBC',
		logo: `${BANK_LOGO_BASE_LINK}hsbc.jpg`,
		minLength: 12,
		maxLength: 17
	},
	{
		code: 'MBSB',
		bankName: 'MBSB',
		logo: `${BANK_LOGO_BASE_LINK}mbsb.jpg`,
		minLength: 10,
		maxLength: 16
	},
	{
		code: 'OCBC',
		bankName: 'OCBC BANK',
		logo: `${BANK_LOGO_BASE_LINK}ocbc.jpg`,
		minLength: 10,
		maxLength: 15
	},
	{
		code: 'UOB',
		bankName: 'UOB BANK',
		logo: `${BANK_LOGO_BASE_LINK}uobbank.png`,
		minLength: 10,
		maxLength: 12
	},
	{
		code: 'BSN',
		bankName: 'BSN',
		logo: `${BANK_LOGO_BASE_LINK}bsn.png`,
		minLength: 16,
		maxLength: 16
	},
	{
		code: 'GXBANK',
		bankName: 'GXBANK',
		logo: `${BANK_LOGO_BASE_LINK}gxbank.png`,
		minLength: 12,
		maxLength: 13
	},
	{
		code: 'ALLIANCE_BANK',
		bankName: 'ALLIANCE BANK',
		logo: `${BANK_LOGO_BASE_LINK}allianceBank.png`,
		minLength: 15,
		maxLength: 15
	},
	{
		code: 'BANK_RAKYAT',
		bankName: 'BANK RAKYAT',
		logo: `${BANK_LOGO_BASE_LINK}bankRakyat.jpg`,
		minLength: 10,
		maxLength: 12
	},
	{
		code: 'STANDARD_CHARTERED',
		bankName: 'STANDARD CHARTERED',
		logo: `${BANK_LOGO_BASE_LINK}standardChartered.png`,
		minLength: 12,
		maxLength: 12
	},

	{
		code: 'TNG',
		bankName: 'TNG',
		logo: `${BANK_LOGO_BASE_LINK}tng.png`
	},

	//ADD LOGO IN FUTUER PLEASE!!!!
	{
		code: 'AMBANK',
		bankName: 'AMBANK',
		minLength: 12,
		maxLength: 14
	},
	{
		code: 'AL_RAJHI',
		bankName: 'AL RAJHI BANK',
		minLength: 15,
		maxLength: 15
	},
	{
		code: 'KUWAIT_FINANCE',
		bankName: 'KUWAIT FINANCE HOUSE',
		minLength: 12,
		maxLength: 12
	},
	{
		code: 'CITIBANK',
		bankName: 'CITIBANK',
		minLength: 10,
		maxLength: 16
	},
	{
		code: 'BOOST_BANK',
		bankName: 'BOOST BANK',
		minLength: 12,
		maxLength: 14
	},
	{
		code: 'AEON_BANK',
		bankName: 'AEON BANK',
		minLength: 8,
		maxLength: 13
	},
	{
		code: 'RYT_BANK',
		bankName: 'RYT BANK',
		minLength: 10,
		maxLength: 14
	}
];

export const getBankLogoByName = (name: string): string => BANK_CONFIG.find(bank => bank.bankName === name)?.logo ?? DEFAULT_BANK_LOGO;

const DEFAULT_MIN_LENGTH = 10;
const DEFAULT_MAX_LENGTH = 16;
export const validateAccountNumber = (bankName: string, accNo: string): boolean => {
	const bank = BANK_CONFIG.find(b => b.bankName.toUpperCase() === bankName.toUpperCase());
	const isDigits = /^\d+$/.test(accNo);
	const notRepetitive = !/^(\d)\1+$/.test(accNo);
	if (!bank || bank.minLength == null) {
		return isDigits && accNo.length >= DEFAULT_MIN_LENGTH && accNo.length <= DEFAULT_MAX_LENGTH;
	} else {
		return isDigits && notRepetitive && accNo.length >= bank.minLength && accNo.length <= bank.maxLength;
	}
};
